var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconVolumeMute = function SvgIconVolumeMute(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "80.000000pt",
    height: "80.000000pt",
    viewBox: "0 0 80.000000 80.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,80.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293 586 l-72 -64 92 -88 92 -89 3 139 c4 193 -4 200 -115 102z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 621 c-4 -5 69 -83 161 -173 293 -286 312 -303 326 -289 9 9 -38 61 -223 241 -129 126 -240 229 -247 229 -6 1 -14 -3 -17 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 493 c-4 -3 -7 -41 -7 -83 0 -92 6 -99 87 -107 53 -5 64 -11 124 -64 62 -55 115 -78 107 -46 -5 19 -304 308 -311 300z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconVolumeMute);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-volume-mute.61092583bb52e96ef1b806c7079b722a.svg";